// src/context/AuthContext.js
import { createContext, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout as reduxLogout } from "../redux/actions/authActions";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  
  // Get auth state from Redux
  const { isAuthenticated, user, token } = useSelector(state => state.auth);
  
  const login = (token, userData) => {
    // Login is handled by Redux action, so this just updates localStorage
    localStorage.setItem("token", token);
    localStorage.setItem("userData", JSON.stringify(userData));
  };

  const logout = () => {
    dispatch(reduxLogout());
  };

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      user,
      token,
      login, 
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);